/**
 * File: useTourButtonController.ts
 * Path: apps/admin/src/modules/layout/hooks/useTourButtonController.ts
 * Description: What the ? icon in a page header does: open the Help dialog.
 */

import { useHelp } from "@/shared/hooks/useTourState";

export const useTourButtonController = () => ({ openHelp: useHelp((s) => s.openHelp) });
